import React, { memo } from 'react';

const ProfileImage = memo(({ darkMode }) => {
    const borderClass = 'border-2 border-gray-100 dark:border-transparent'; 
    const shadowClass = 'shadow-lg hover:shadow-xl dark:shadow-none transition-shadow duration-300';

    return (
        <div
            className={`rounded-full mx-auto overflow-hidden ${borderClass} ${shadowClass}`}
            style={{
                width: '120px',
                height: '120px',
            }}
        >
            <img
                src="/images/profile.webp"
                alt="Profile"
                className="w-full h-full object-cover transition-transform duration-300 ease-in-out hover:scale-[1.05]"
                loading="eager"
            />
        </div>
    );
});

ProfileImage.displayName = 'ProfileImage';

export default ProfileImage;